export default __webpack_public_path__ + "static/media/question.83fae7e5.svg";